//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import commonlist from "@/pcpage/hr/common/commonlist";
    export default {
      extends : commonlist,
      name: "positioninfolist",
      methods: {
        async initView(){
            this.initParam();
        },
        /**
         * 初始化公用参数
         */
        initParam(){
            this.listAction = "api/api/getRecruitPostList";
        },
        /**
         * 打开业务单据
         */
        doEdit(id){
          let url = "/recruit/resumeload";
          let oQuery = {};
          oQuery["appkey"] = id;
          this.openWin(url,oQuery);
        },
        /**
         * 查询
         */
        query(){
          this.currPage = 1;
          this.$refs.pagination.handleCurrentChangeNoQuery(this.currPage);
          this.dopagequery();
        },
      },
    created(){
       this.initView().then(() => {
          this.dopagequery();
       });
    },


    }



// WEBPACK FOOTER //
// ./src/pcpage/hr/recruitment/resumeApply/positioninfolist.vue